export default __webpack_public_path__ + "static/media/top_banner_bg2.022439f4.jpg";